import { DONATION_THANK_YOU_MERGE_FIELDS } from '../constants/donationConfirmation.js'

export function parseGoogleFormUrl(value) {
  let url
  try {
    url = new URL(value.trim())
  } catch {
    throw new Error('Paste a valid Google Form link beginning with https://.')
  }

  const fullForm = url.hostname === 'docs.google.com' && /^\/forms\/(?:u\/\d+\/)?d\/(?:e\/)?[\w-]+\/viewform\/?$/.test(url.pathname)
  const shortForm = url.hostname === 'forms.gle' && /^\/[\w-]+\/?$/.test(url.pathname)
  if (url.protocol !== 'https:' || url.username || url.password || url.port || (!fullForm && !shortForm)) {
    throw new Error('Use a Google Form responder link or pre-filled link, rather than the form editing link.')
  }

  return url
}

export function googleFormAnswerFields(value) {
  const url = parseGoogleFormUrl(value)
  if (url.hostname !== 'docs.google.com') return []

  return [...new Set(url.searchParams.keys())]
    .filter(key => /^entry\.\d+$/.test(key))
    .map((key, index) => ({
      value: key,
      label: `Answer ${index + 1}: ${url.searchParams.getAll(key).join(', ') || '(blank)'}`
    }))
}

export function buildGoogleFormLink(value, mappings) {
  const url = parseGoogleFormUrl(value)
  const availableFields = googleFormAnswerFields(value).map(field => field.value)
  const selected = Object.entries(mappings)
  const targets = new Set()

  for (const [variable, target] of selected) {
    if (!DONATION_THANK_YOU_MERGE_FIELDS.some(field => field.value === variable)) {
      throw new Error('Choose one of the available donor details.')
    }
    if (!availableFields.includes(target)) {
      throw new Error('Choose a form answer for every checked donor detail. Paste a pre-filled link to see the available answers.')
    }
    if (targets.has(target)) {
      throw new Error('Choose a different form answer for each donor detail.')
    }
    targets.add(target)
  }

  // Sample answers identify fields, but must not be sent to donors.
  for (const key of [...url.searchParams.keys()]) {
    if (/^entry\./.test(key) || key === 'emailAddress') url.searchParams.delete(key)
  }
  for (const [variable, target] of selected) {
    url.searchParams.set(target, `{{ ${variable} }}`)
  }
  if (selected.length) url.searchParams.set('usp', 'pp_url')

  return url.toString()
}

export function renderGoogleFormLink(value, donorValues) {
  let url
  try {
    url = parseGoogleFormUrl(value)
  } catch {
    return value
  }
  if (url.hostname !== 'docs.google.com') return value

  let changed = false
  for (const [key, answer] of [...url.searchParams.entries()]) {
    if (!/^entry\.\d+$/.test(key)) continue
    const token = answer.match(/^\{\{\s*(donor\.(?:first_name|last_name|email))\s*\}\}$/)
    if (!token) continue

    const donorValue = donorValues[token[1]]
    if (donorValue) url.searchParams.set(key, donorValue)
    else url.searchParams.delete(key)
    changed = true
  }

  return changed ? url.toString() : value
}
